import { observer } from 'mobx-react';
import React, { Component } from 'react';
import Gene from 'stores/models/Gene';

interface IProps {
  model: Gene;
}

class View extends Component<IProps> {
  render() {
    const { info, state, states, toggle } = this.props.model;
    const { percent, prefix, qualifier } = info;
    const interactivityCss = states.length > 1 ? 'is-clickable' : 'disabled';

    return (
      <div
        className={`gene m-1 is-flex-centered is-unselectable ${interactivityCss} is-family-code`}
        onClick={toggle}
        style={{ flexGrow: percent }}
      >
        <div className='is-flex-centered'>
          <span className='prefix has-text-weight-light'>{prefix}</span>
          <span className='has-text-weight-bold'>{qualifier}</span>
          <span className='superscript has-text-centered has-text-weight-bold'>
            {state.superscript}
          </span>
        </div>
      </div>
    );
  }
}

const GeneBlock = observer(View);
export default GeneBlock;
